const apiKey= 'ZTZl_sGfMnVG9dekIS83-9buaNeg5N6T0riUuUqGU1seqTyOzid29dFjNFm26JjTriVhRiW8-caUzwNmv_zArdcrZ2jbadcCpNMduZC1PJMWBQIoJLel40p5kHwcX3Yx';

let Yelp={
    searchYelp(term,location,sortBy) {
        return fetch(`https://cors-anywhere.herokuapp.com/https://api.yelp.com/v3/businesses/search?term=${term}&location=${location}&sort_by=${sortBy}`,
        {headers:{
            Authorization:`Bearer ${apiKey}`
        }}).then((response)=>{
            return response.json();}).then(jsonResponse=>{
                if(jsonResponse.businesses){
                    return jsonResponse.businesses.map((business)=>{
                        return{
                            id:business.id,
                            imageSrc: business.image_url,
                            name:business.name,
                            address:business.location.address1,
                            city: business.location.city,
                            state:business.location.state,
                            zipCode: business.location.zip_code,
                            category:business.categories[0].title,
                            rating: business.rating,
                            reviewCount:business.review_count
                        }
                    })
                }

            })
    
    }
};


export default Yelp;